module.exports = __webpack_public_path__ + "img/photos/placeholders/already-played@2x.jpg";